import XGrid from "@/components/grid/XGridPop";
import {CONSTANT as constant} from '@/services/constant';
import {mapGetters} from "vuex";
import api from "@/services/api";
import {loadBaseCodeData} from "@/services/baseCodeSource";

const GridPopMixin = {
	name: 'xGridPopList',
	components: {
		XGrid,
	},
	/**
	 * 将当前用户加载到页面中
	 */
	computed: {
		...mapGetters('account', ['user'])
	},
	data() {
		return {
			api,
			params: this.$route.query,
			constant,
			clickCheck: true,//点击选中行
			tableType: 'radio',//表格类型 默认单选
			tableName: '',
		}
	},
	methods: {
		/**
		 * 获取年份的筛选
		 * @return {[]}
		 */
		getYearOptions() {
			let yearArr = [];
			let nowYear = Math.floor(new Date().getFullYear());
			for (let i = -10; i < 10; i++) {
				yearArr.push({
					label: nowYear + i,
					value: nowYear + i,
				})
			}
			return yearArr
		},
		/**
		 * 表单方法
		 */
		chooseRow({row, column}) {
			if (this.clickCheck && column.type !== 'checkbox' && column.type !== 'radio') {
				if (this.tableType === 'checkbox') {
					this.$refs['grid'].$refs['xGrid'].toggleCheckboxRow(row).then(() => {
					})
				} else {
					this.$refs['grid'].$refs['xGrid'].setRadioRow(row).then(() => {
					})
				}
			}
		},
		/**
		 * 打开加载/关闭加载
		 * @param status
		 */
		loading(status) {
			this.$refs['grid'].loading = status;
		},
		/**
		 * 获取组件数据 固定写法
		 */
		getSelectData() {
			this.$refs.grid.getSelectData(this.tableType);
		},
		/**
		 * 组件回传数据 固定写法
		 */
		returnForm(data) {
			this.$emit('getTableData', data, this.tableName);
		},
		/**
		 * 刷新组件
		 */
		refresh() {
			this.$refs['grid'].reloadData();
		},
		/**
		 * 预加载函数 用来加载 列表查询中的通用代码 或其他代码
		 */
		async loadBaseData() {
			return new Promise((resolve, reject) => {
				try {
					resolve({});
				} catch (e) {
					reject(e);
				}
			})
		},
		/**
		 * 筛选条件动态加载
		 * 当筛选条件有动态加载的需求时调用 一般在loadBaseData的最后调用
		 * @param data 处理数据 Object
		 */
		loadSearchOption(data) {
			for (let item in data) {
				if (Object.prototype.hasOwnProperty.call(data, item)) {
					if (this.formConfig.items && this.formConfig.items.length) {
						this.formConfig.items.forEach(e => {
							if (e.field === item) {
								e.itemRender.options = data[item];
							}
						})
					}
				}
			}
		}
	},
	mounted() {
		//加载其他预加载代码
		this.loadBaseData().catch();
		//加载通用代码
		if (!this.formConfig) {
			return
		}
		if (this.formConfig.items && this.formConfig.items.length) {
			this.formConfig.items.forEach(async e => {
				if (e.baseCode) {
					e.itemRender.options = e.itemRender.options.concat(await loadBaseCodeData(e.baseCode))
				}
				// if (e.auditStatus) {
				// 	e.itemRender.options = e.itemRender.options.concat(await loadAuditList(e.auditStatus))
				// }
			})
		}
	}
}

export {
	GridPopMixin
}